import { Box } from '@mui/material'
import React from 'react'

const ComingSoon = () => {
  return (
    <Box
                 sx={{
                   fontFamily: 'Arial, sans-serif', // Change the font family
                   fontSize: '24px', // Adjust the font size
                   color: '#333', // Change the text color
                   textAlign: 'center', // Center the text
                   marginTop: '10vh', // Move it down a bit
                   transform: 'translateY(-50%)', // Center it vertically
                   letterSpacing: '1px', // Add some letter spacing
                   textTransform: 'uppercase', // Uppercase the text
                   fontWeight: 'bold', // Make it bold
                   opacity: 0.8, // Adjust the opacity
                   transition: 'opacity 0.3s ease', // Add a fade-in transition
                   '&:hover': {
                     opacity: 1, // Fade in on hover
                   },
                 }}
               >
                 Coming soon ...
               </Box>
  )
}

export default ComingSoon